import { capitalize } from "utils/capitalize";

export const HOTJAR_SITE_ID_TEST = 3514786;
export const HOTJAR_VERSION = 6;
export const HOTJAR_SITE_ID_PROD = 6532877;
export const GA_TRACKING_ID_TEST = "G-3K102H2YK2";
export const GA_TRACKING_ID_PROD = "G-DRBYF916QF";

export const B2C_CLIENT_ID = "ddcdc39a-98dd-4fcf-ae52-826153f33831";
export const B2C_AUTHORITY_URL =
  "https://bonverb2c.b2clogin.com/bonverb2c.onmicrosoft.com/b2c_1_signin";
export const PROD_ACCESS_SCOPE =
  "https://bonverb2c.onmicrosoft.com/ed1a9502-dad0-49b1-be47-2750509252a8/access_as_user";
export const DEV_ACCESS_SCOPE =
  "https://bonverb2c.onmicrosoft.com/a0818d14-8de1-4f50-af25-796ed0107909/access_as_user";

export const DEV_BASE_URL =
  "https://bonver-customerportal-webapi-test.azurewebsites.net/v1";
export const PROD_BASE_URL =
  "https://bonver-customerportal-webapi-prod.azurewebsites.net/v1";

export const HELP_CENTER_STATUS_COLOR_MAP: { [status: string]: string } = {
  new: "#FF644F",
  open: "#FFA770",
  pending: "#FFC857",
  hold: "#FFD685",
  solved: "#88ADFB",
  closed: "#00656C",
};

export const HELP_CENTER_STATUS_OPTIONS = [
  {
    label: "Status",
    value: "",
  },
  ...Object.keys(HELP_CENTER_STATUS_COLOR_MAP).map((value) => ({
    label: capitalize(value),
    value,
  })),
];

export const FREIGHT_COLOR_MAP: { [key: string]: string } = {
  Undefined: "#9eb2b5",
  Unknown: "#9eb2b5",

  // Regions
  Sweden: "#016ba9",
  Finland: "#012d67",
  Norway: "#d52c3c",
  Denmark: "#bd0c2d",
  EU: "#e2b003",
  Worldwide: "#3a8e35",

  // Service types
  B2B: "#ffa770",
  B2C: "#ffc199",
  Box: "#ffc858",
  Charge: "#fed785",
  Courier: "#a292f2",
  Home: "#607d8b",
  Linehaul: "#002561",
  Mail: "#004384",
  Parcel: "#33658A",
  PuP: "#00656c",
  Return: "#5f88d2",
  Multi: "#049975",

  // Cost types
  "Freight costs": "#9ea0a1",
  "Fuel surcharges": "#7b7d7d",
  "Other charges": "#6a6b6b",
};

export const CARRIER_COLOR_MAP: { [key: string]: string } = {
  // Bring (all variants)
  BRING: "#40D328",
  Bring: "#40D328",
  "Bring Parcels AB": "#40D328",
  "Bring Mail": "#00A651",

  // PostNord
  PostNord: "#005293",
  "Postnord SE": "#005293",

  // Early Bird
  "Early Bird": "#DD7F4A",

  // DHL
  DHL: "#FFCC00",
  "DHL Freight": "#FFCC00",

  // UPS
  UPS: "#351C15",

  // Budbee
  Budbee: "#002F26",

  // Posti (Finnish Post – brand orange)
  Posti: "#FF6B00",

  // Airmee (tech-first last-mile, teal-green)
  Airmee: "#01A87C",

  // Jetpak (express courier)
  Jetpak: "#C8102E",

  // Dachser (dark forest green)
  Dachser: "#007A47",

  // TNT
  TNT: "#FF6200",

  // FedEx
  FedEx: "#4D148C",

  // Others
  "DB Schenker": "#CC0000",
  GLS: "#00539B",
  Instabox: "#FF6B35",
  DPD: "#DC0032",
  Asendia: "#005EB8",
  Omniva: "#FDBF00",
};

// Fallback palette for carriers not listed in CARRIER_COLOR_MAP
export const CARRIER_FALLBACK_COLORS = [
  "#5C6BC0",
  "#26A69A",
  "#EF5350",
  "#66BB6A",
  "#FFA726",
  "#AB47BC",
  "#29B6F6",
  "#FF7043",
  "#9CCC65",
  "#26C6DA",
];

// Fallback wording for a bot progress step, keyed by the step name the API
// sends. Only used when a progress event carries no text of its own.
export const BOT_PROGRESS_LABELS: Record<string, string> = {
  get_order: "Looking up the order",
  cancel_order: "Cancelling the order",
  update_order_delivery_details: "Updating the delivery details",
  get_order_tracking_information: "Fetching tracking information",
};

export const BOT_PROGRESS_FALLBACK_LABEL = "Working on it";

// The step the portal shows itself while the question is asked again with the
// page data, see startPageDataAnalysis.
export const BOT_PAGE_DATA_ANALYSIS_LABELS = {
  running: "Analysing the page data",
  completed: "Page data analysed",
};
